import { render } from "./LogoBarComponent.vue?vue&type=template&id=137b65dc&scoped=true"
const script = {}

import "./LogoBarComponent.vue?vue&type=style&index=0&id=137b65dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137b65dc"]])

export default __exports__